<template>
	<div 
		class="modal fade custom-modal auth-modal" 
		id="reset-modal"
		role="dialog" 
		aria-labelledby="reset-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        <i class="fa fa-close"></i>
                    </button>
                </div>

            	<div class="modal-body">
            		<div class="row">
            			<div class="col-xs-12 col-sm-12 col-md-12">
            				<div class="auth-logo">
            					<img src="../../assets/logowithname.png">
            				</div>

            				<p class="text-center small-margin-top">Request Password Reset</p>
            			</div>

            			<div class="col-xs-12 col-sm-12 col-md-12">
				            <form role="form" @submit.prevent="sendRequest">
								<!-- Email field -->
								<div class="form-group" :class="{ 'has-error': errors.has('email') }">
		                            <label for="email">Email</label>

									<input 
										type="text" 
										id="email" 
										name="email" 
										v-model="email" 
										class="form-control" 
										v-validate="rules.email"
										placeholder="user@ezifood.com">

									<error-label :show="errors.has('email')">{{ errors.first('email') }}</error-label>
		                        </div>

								<div class="footer">
								    <div class="row">
								        <div class="col-md-12">
								            <button 
				                            	type="submit"
				                            	:disabled="!email" 
				                            	class="btn btn-warning btn-fill small-margin-top btn-block">Send Request</button>
										</div>
								    </div>
		                        </div>			
							</form>		
						</div>
					</div>		
				</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	props: ['isOpenModal'],

	data() {
		return {
			rules: {
				email: 'required|email',
			},

			email: ''
		}
	},

	watch: {
		/**
		 * Watch for changes in the isOpenModal variable.
		 * Open when true else close
		 * 
		 * @param  {Boolean}  value 
		 * @return {Boolean}       
		 */
		isOpenModal(value) {	
			if (value) {
				this.openModal();
			} else {
				this.closeModal();
			}
		}
	},

	methods: {
		...mapActions({
            showResetModal: 'User/setShowReset',
            requestReset: 'User/requestPasswordReset'
		}),

		/**
		 * Open reset modal. Reset form first.
		 * 
		 * @return null
		 */
		openModal() {
			$('#reset-modal').appendTo('body').modal({
				backdrop: 'static'
			});
		},

		/**
		 * Close login modal then resets form.
		 * 
		 * @return null
		 */
		closeModal() {
			$('#reset-modal').modal('hide');
			this.resetForm();
			this.showResetModal(false);
		},

		/**
		 * Resets login form and also clear form errors.
		 * 
		 * @return null
		 */
		resetForm() {
			this.email = "";
			this.errors.clear();
		},

        /**
         * Send request for resetting password
         * 
         * @return null
         */
		sendRequest() {
			let notification;

			this.showLoader();
			
			this.requestReset({
				    email: this.email
			    })
			    .then((response) => {
			    	notification = {
			    		message: 'A password reset token has been sent to your email',
			    		type: 'success'
			    	};

			    	this.notify(notification);
			    	this.resetForm();
			    	this.closeModal();
			    	this.$router.push({
			    		name: 'reset'
			    	});
			    })
				.catch((error) => {
					this.buildErrorMessages(error)
						.then((data) => {
							notification = {
								message: data,
								type: 'danger'
							};

							this.notify(notification);
						});
				}).then(() => this.hideLoader());
		}
	}
}
</script>


// WEBPACK FOOTER //
// ResetModal.vue?13e6a610